































import { Vue, Component } from "vue-property-decorator";

@Component({})
export default class LoginDisclaimers extends Vue {
  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }


}
